module.exports = require('./InstallmentSellerApplicationView');
